module.exports = require('./InstallmentSellerApplicationView');
